import * as Services from "../../../Service/Service"

export const GetUnderwritingOutputByClientId = (Id) => {
  const params = { Id };

  let res = Services.GETSERVICE(
    `/api/UnderwritingOutput/GetUnderwritingOutputByClientId/${Id}`,
    params,
    {}
  );
  return res;
};

export const UnderwritingOutputReport = (Id, UserId) => {
  const token = localStorage.getItem("token");
  const params = { Id };

  let res = Services.POSTSERVICE(
    `/api/UnderwritingOutput/UnderwritingOutputReport/${Id}?UserId=${UserId}`,
    params,
    token
  );
  return res;
};

// export const UpdateUnderwritingAdjustment = (payload) => {
//   const token = localStorage.getItem("token");

//   return axios.put(
//     `${config.API_URL}/api/ACG_UnderWritingAdjustment/UpdateAdjustment`,
//     payload,
//     {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
// };
